import React, { useMemo, useState, useContext } from 'react';

import { Context } from 'src/context';
import RoutesEnum from 'src/enum/RoutesEnum';

import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import LocalShippingOutlined from '@material-ui/icons/LocalShippingOutlined';
import SystemUpdateAltOutlined from '@material-ui/icons/SystemUpdateAltOutlined';
import AssignmentTurnedInOutlined from '@material-ui/icons/AssignmentTurnedInOutlined';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import SupervisedUserCircleOutlinedIcon from '@material-ui/icons/SupervisedUserCircleOutlined';
import AllInboxOutlined from '@material-ui/icons/AllInboxOutlined';
import DeviceHubOutlined from '@material-ui/icons/DeviceHubOutlined';

import StarIcon from '@material-ui/icons/StarBorder';
import InfoIcon from '@material-ui/icons/InfoOutlined';

import { history } from 'src/App';

import { Sidebar } from './components/sidebar';
import { Navbar } from './components/navbar';
import PermissionsEnum from 'src/enum/PermissionsEnum';

export interface IMenuItem {
  name: string;
  icon: any;
  onClick: () => void;
  page?: string;
  disabled?: boolean;
  admin?: boolean;
  subActions?: any;
  emailsPermissions?: string[]
  hideMenu?: boolean
  permission?: string
  routesChildToActive?: string[]
}

const PermanentDrawerLeft: React.FC = ({ children }: any) => {
  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(true);
  const { userAuth } = useContext(Context);

  const redirectInstance = (route: string) => {
    window.stop();
    history.push(route);
  };

  const goToPage = (page: string) => {
    return page === '' ? null : redirectInstance(page);
  };

  const itemsMenu: Array<IMenuItem[]> = useMemo(
    () => [
      [
        {
          name: 'Veículos em PDI',
          icon: DashboardOutlinedIcon,
          onClick: () => goToPage(RoutesEnum.DASHBOARD_ROUTE),
          admin: false,
          page: RoutesEnum.DASHBOARD_ROUTE,
        },
        {
          name: 'Veículos em PDI',
          icon: DashboardOutlinedIcon,
          onClick: () => goToPage(RoutesEnum.ADMIN_DASHBOARD_ROUTE),
          admin: true,
          page: RoutesEnum.ADMIN_DASHBOARD_ROUTE,
          permission: PermissionsEnum.VIEW_VEHICLES_IN_PDI,
          routesChildToActive: [
            RoutesEnum.VIEW_VEHICLE_ROUTE_REDIRECT,
          ]
        },
        {
          name: 'Last Mile Track',
          icon: LocalShippingOutlined,
          onClick: () => goToPage(RoutesEnum.LAST_MILE_TRACK_ROUTE),
          admin: false,
          page: RoutesEnum.LAST_MILE_TRACK_ROUTE,
        },
        {
          name: 'Last Mile Track',
          icon: LocalShippingOutlined,
          onClick: () => goToPage(RoutesEnum.ADMIN_LAST_MILE_TRACK_ROUTE),
          admin: true,
          page: RoutesEnum.ADMIN_LAST_MILE_TRACK_ROUTE,
          permission: PermissionsEnum.VIEW_LAST_MILE_TRACK
        },
        {
          name: 'Monitoramento Veículos',
          icon: SystemUpdateAltOutlined,
          onClick: () => goToPage(RoutesEnum.ADMIN_MONITORING_VEHICLES_ROUTE),
          admin: true,
          page: RoutesEnum.ADMIN_MONITORING_VEHICLES_ROUTE,
          permission: PermissionsEnum.VIEW_VEHICLE_MONITORING
        },
        {
          name: 'Relatório de Expedidos',
          icon: AssignmentTurnedInOutlined,
          onClick: () => goToPage(RoutesEnum.REPORT_DISPATCHED_VEHICLES_ROUTE),
          admin: false,
          page: RoutesEnum.REPORT_DISPATCHED_VEHICLES_ROUTE,
        },
        {
          name: 'Relatório de Expedidos',
          icon: AssignmentTurnedInOutlined,
          onClick: () => goToPage(RoutesEnum.ADMIN_REPORT_DISPATCHED_VEHICLES_ROUTE),
          admin: true,
          page: RoutesEnum.ADMIN_REPORT_DISPATCHED_VEHICLES_ROUTE,
          permission: PermissionsEnum.VIEW_DISPATCHED_REPORT
        },
        {
          name: 'Solicitações',
          icon: DescriptionOutlinedIcon,
          onClick: () => {},
          admin: true,
          page: undefined,
          permission: PermissionsEnum.VIEW_REQUESTS,
          emailsPermissions: [
            'bruno.fattore@sada.com.br',
            'jhemersonlucas@hotmail.com',
            'deziele.silva@localiza.com',
            'hemerson.silva@localiza.com',
            'alana.condini@stellantis.com',
            'brunofattore@hotmail.com',
            'hugo.alonso@unidas.com.br'
          ],
          subActions: [
            {
              name: 'Todas solicitações',
              onClick: () => goToPage(RoutesEnum.ADMIN_REQUEST_PREPARATION_LIST_ROUTE),
              page: RoutesEnum.ADMIN_REQUEST_PREPARATION_LIST_ROUTE,
            },
          ],
        },
        {
          name: 'Solicitações',
          icon: DescriptionOutlinedIcon,
          onClick: () => { },
          admin: false,
          page: undefined,
          emailsPermissions: [
            'bruno.fattore@sada.com.br',
            'jhemersonlucas@hotmail.com',
            'deziele.silva@localiza.com',
            'hemerson.silva@localiza.com',
            'alana.condini@stellantis.com',
            'brunofattore@hotmail.com',
            'hugo.alonso@unidas.com.br'
          ],
          subActions: [
            {
              name: 'Preparação',
              onClick: () => goToPage(RoutesEnum.REQUEST_PREPARATION_CREATE_ROUTE),
              page: RoutesEnum.REQUEST_PREPARATION_CREATE_ROUTE,
            },
            {
              name: 'Minhas Solicitações',
              onClick: () => goToPage(RoutesEnum.REQUEST_PREPARATION_LIST_ROUTE),
              page: RoutesEnum.REQUEST_PREPARATION_LIST_ROUTE,
            },
          ],
        },
        {
          name: 'Estoque',
          icon: AllInboxOutlined,
          onClick: () => goToPage(RoutesEnum.STOCK_PAGE_ROUTE),
          admin: false,
          page: RoutesEnum.STOCK_PAGE_ROUTE,
        },
        {
          name: 'Integração',
          icon: DeviceHubOutlined,
          onClick: () => goToPage(RoutesEnum.API_INTEGRATION_PAGE_ROUTE),
          admin: false,
          page: RoutesEnum.API_INTEGRATION_PAGE_ROUTE,
          hideMenu: !userAuth?.enableApi
        },
        {
          name: 'Métricas Operacionais',
          icon: StarIcon,
          onClick: () => goToPage(RoutesEnum.OPERATIONAL_METRICS_PAGE_ADMIN_ROUTE),
          admin: true,
          page: RoutesEnum.OPERATIONAL_METRICS_PAGE_ADMIN_ROUTE,
          permission: PermissionsEnum.VIEW_OPERATIONAL_METRICS
        },
        {
          name: 'Métricas Operacionais',
          icon: StarIcon,
          onClick: () => goToPage(RoutesEnum.OPERATIONAL_METRICS_PAGE_ROUTE),
          admin: false,
          page: RoutesEnum.OPERATIONAL_METRICS_PAGE_ROUTE
        },
        {
          name: 'Estoque',
          icon: AllInboxOutlined,
          onClick: () => goToPage(RoutesEnum.STOCK_PAGE_ADMIN_ROUTE),
          admin: true,
          page: RoutesEnum.STOCK_PAGE_ADMIN_ROUTE,
          permission: PermissionsEnum.VIEW_INVENTORY
        },
        {
          name: 'Clientes',
          icon: GroupOutlinedIcon,
          onClick: () => goToPage(RoutesEnum.VIEW_CLIENT_ROUTE),
          admin: true,
          page: RoutesEnum.VIEW_CLIENT_ROUTE,
          permission: PermissionsEnum.VIEW_CUSTOMERS,
          routesChildToActive: [
            RoutesEnum.EDIT_USER_ROUTE_REDIRECT,
            RoutesEnum.ADD_USER_ROUTE,
            RoutesEnum.EDIT_CLIENT_ROUTE_REDIRECT
          ]
        },
        {
          name: 'Equipe',
          icon: SupervisedUserCircleOutlinedIcon,
          onClick: () => { },
          admin: true,
          page: RoutesEnum.VIEW_TEAM_ROUTE,
          permission: PermissionsEnum.VIEW_TEAM,
          subActions: [
            {
              name: 'Lista de Usuários',
              onClick: () => goToPage(RoutesEnum.VIEW_TEAM_ROUTE),
              page: RoutesEnum.VIEW_TEAM_ROUTE,
            },
            {
              name: 'Níveis de acesso',
              onClick: () => goToPage(RoutesEnum.VIEW_GROUP_ROUTE),
              page: RoutesEnum.VIEW_GROUP_ROUTE,
              permission: PermissionsEnum.VIEW_GROUP_ROUTE,
              routesChildToActive: [
                RoutesEnum.ADD_GROUP_ROUTE,
                RoutesEnum.VIEW_GROUP_USERS_REDIRECT,
                RoutesEnum.EDIT_GROUP_ROUTE_REDIRECT,
              ]
            }
          ],
        },
        {
          name: 'Gerenciar avaliações',
          icon: StarIcon,
          onClick: () => goToPage(RoutesEnum.MANAGE_REVIEWS_ADMIN_ROUTE),
          admin: true,
          page: RoutesEnum.MANAGE_REVIEWS_ADMIN_ROUTE,
          permission: PermissionsEnum.VIEW_MANAGE_REVIEWS
        },
        {
          name: 'FAQ',
          icon: InfoIcon,
          onClick: () => goToPage(RoutesEnum.FAQ_ROUTE),
          admin: false,
          page: RoutesEnum.FAQ_ROUTE,
        },
      ]
    ],
    [userAuth],
  );

  return (
    <div className="flex h-full">
      <Navbar />
      <Sidebar items={itemsMenu} isOpen={isSidebarOpen} setOpen={setSidebarOpen} />

      <main className="flex flex-1 mt-16 py-6">
        <div className="flex flex-row h-full w-full">
          <div className={`w-full h-full duration-200 ${isSidebarOpen ? 'pl-64' : 'pl-16'}`}>{children}</div>
        </div>
      </main>
    </div>
  );
};

export default PermanentDrawerLeft;
